import CourseUnitPage from './CourseUnitPage';

export default CourseUnitPage;
